import type { GridOption } from '@/common/utils/types';

export const transformSelectedRows = <T>(selectedRows?: T[]): T | undefined => {
  if (!selectedRows || selectedRows.length === 0) return undefined;
  return selectedRows[selectedRows.length - 1];
};

export const reverseTransformSelectedRow = <T>(selectedRow?: T): T[] => {
  return selectedRow ? [selectedRow] : [];
};

export const transformHighlightedRows = <T>(rows: T[], highlightIndex?: number): T[] => {
  if (highlightIndex === undefined || highlightIndex < 0 || highlightIndex >= rows.length) {
    return [];
  }
  return [rows[highlightIndex]];
};

export const transformSelectedRowsToHighlightedRows = <T>(selectedRows?: T[]): T[] => {
  return selectedRows?.length ? selectedRows : [];
};

export const transformEmptyText = (gridOption?: GridOption): string | undefined => {
  return gridOption?.emptyText;
};
